import { useLanguage } from '../../i18n';

interface RisksSectionProps {
  risks: string;
  setRisks: (value: string) => void;
  isDemo?: boolean;
}

function RisksSection({ risks, setRisks, isDemo = false }: RisksSectionProps) {
  const { t } = useLanguage();

  return (
    <div className="card p-4" data-testid="risks-section">
      <div className="text-terminal-muted text-xs mb-3 uppercase tracking-wide">
        # {t.form.risks}
      </div>
      <textarea
        value={risks}
        onChange={(e) => setRisks(e.target.value)}
        placeholder={t.form.risksPlaceholder}
        className={`terminal-input min-h-[80px] resize-none ${isDemo ? 'bg-terminal-input/60 cursor-not-allowed' : ''}`}
        rows={3}
        readOnly={isDemo}
        data-testid="input-risks"
      />
      <p className="mt-1 text-terminal-dim text-xs">{t.form.onePerLine}</p>
    </div>
  );
}

export default RisksSection;

